export const UNASSIGNED_FILTER_VALUE = ''
export const ALL_BUILDINGS = 'All Buildings'
export const ALL_LEVELS = 'All Levels'
export const ALL_ZONES = 'All Zones'
export const UNASSIGNED = 'Unassigned'

export const zoneBaseName = 'Zone'
